import { Injectable, signal } from '@angular/core';

export interface Toast {
  id: number;
  tone: 'error' | 'ok';
  message: string;
}

/**
 * Toasts are for failures, and for actions whose effect isn't visible on screen.
 * A save that visibly updates a row gets no toast — the row is the feedback.
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 1;
  readonly toasts = signal<Toast[]>([]);

  error(message: string): void {
    this.push('error', message, 8000);
  }

  /** Use only when the result is off-screen (e.g. a background job was queued). */
  ok(message: string): void {
    this.push('ok', message, 4000);
  }

  dismiss(id: number): void {
    this.toasts.update((list) => list.filter((toast) => toast.id !== id));
  }

  private push(tone: Toast['tone'], message: string, dwell: number): void {
    const id = this.nextId++;
    this.toasts.update((list) => [...list, { id, tone, message }]);
    setTimeout(() => this.dismiss(id), dwell);
  }
}
